import {OauthClientModel, UnsavedOauthClientModel} from '../../../models/api/oauthClientModel';
import {computeOauthClientEditorFormErrors} from '../../tools/oauth_clients/oauthClientEditorFormErrors';

export interface OauthClientState {
  clientId: string;
  redirectUrls: string[];
}

export interface OauthClientEditorState {
  oauthClientState: OauthClientState;
  initialOauthClient?: OauthClientModel;
}

export const OauthClientEditorState = {
  get default(): OauthClientEditorState {
    return {
      oauthClientState: {
        clientId: '',
        redirectUrls: [],
      },
    };
  },

  createInitialState(initialOauthClient: OauthClientModel | undefined): OauthClientEditorState {
    if (!initialOauthClient) {
      return {...this.default};
    }

    return {
      ...this.default,
      initialOauthClient,
      oauthClientState: {
        clientId: initialOauthClient.clientId,
        redirectUrls: initialOauthClient.redirectUrls,
      },
    };
  },

  toOauthClient(state: OauthClientEditorState): UnsavedOauthClientModel {
    const {oauthClientState} = state;

    return {
      redirectUrls: oauthClientState.redirectUrls,
    };
  },

  hasDiff(a: OauthClientEditorState, b: OauthClientEditorState) {
    if (a === b) {
      return false;
    }

    const aState = a.oauthClientState;
    const bState = b.oauthClientState;

    if (aState.redirectUrls.length !== bState.redirectUrls.length) {
      return true;
    }

    if (aState.redirectUrls.some((aUrl, aIndex) => aUrl !== bState.redirectUrls[aIndex])) {
      return true;
    }

    return false;
  },

  computeFormErrors(state: OauthClientEditorState) {
    return computeOauthClientEditorFormErrors(state);
  },
};
